import { Flipper } from 'legacy/contexts/flipper/FlipperContext'
import useAccessControl from 'legacy/components/AccessControl/useAccessControl'

export const useIsI18nEnabled = () => {
  const hasAccess = useAccessControl()
  const hasI18nAccess = hasAccess({
    flippers: Flipper.EnterpriseI18nHeroBanners,
  })
  return hasI18nAccess
}
